import { useCallback, useEffect } from 'react';

const excludePathname = ['/services'];

export default function (pathname) {
  const sessionStorageScroll = sessionStorage.getItem(pathname);

  useEffect(() => {
    if (!sessionStorageScroll || excludePathname.includes(pathname)) {
      window.scrollTo(0, 0);
      return;
    }
    window.scrollTo(0, parseInt(sessionStorageScroll));
    sessionStorage.removeItem(pathname);
  }, [sessionStorageScroll, pathname]);

  const handleScroll = useCallback(
    (event) => {
      const scrollY = Math.floor(event.currentTarget.scrollY);
      sessionStorage.setItem(pathname, scrollY);
    },
    [pathname]
  );

  useEffect(() => {
    addEventListener('scroll', handleScroll);
    return () => removeEventListener('scroll', handleScroll);
  }, [handleScroll]);
}
